import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode removed to prevent double API calls in development
// In production, this doesn't affect behavior
root.render(<App />);
